import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/no-img.bb9c4fe3.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-71837e11"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "SAlbum"
};
var _hoisted_2 = {
  class: "SAlbum-box"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  class: "Album-item-left"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createCommentVNode(" 专辑item项 "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.albumList, function (item) {
    var _item$artist;

    return _openBlock(), _createElementBlock("div", {
      class: "Album-item",
      key: item.id,
      onClick: function onClick($event) {
        return _ctx.albumClick(item.id);
      }
    }, [_createElementVNode("div", _hoisted_4, [_createCommentVNode(" 图片 "), _createVNode(_component_el_image, {
      src: item.picUrl
    }, {
      placeholder: _withCtx(function () {
        return [_hoisted_5];
      }),
      _: 2
      /* DYNAMIC */

    }, 1032
    /* PROPS, DYNAMIC_SLOTS */
    , ["src"]), _createCommentVNode(" 专辑名 "), _createElementVNode("span", {
      class: "album-name linelittle",
      innerHTML: _ctx.lightKeyword(item.name, _ctx.inputValue)
    }, null, 8
    /* PROPS */
    , _hoisted_6)]), _createCommentVNode(" 歌手 "), _createElementVNode("span", {
      class: "songer-name",
      innerHTML: _ctx.lightKeyword((_item$artist = item.artist) === null || _item$artist === void 0 ? void 0 : _item$artist.name, _ctx.inputValue)
    }, null, 8
    /* PROPS */
    , _hoisted_7)], 8
    /* PROPS */
    , _hoisted_3);
  }), 128
  /* KEYED_FRAGMENT */
  ))])]);
}